const React = require("react");
const PropTypes = require("prop-types");

const JobPostingForm = React.lazy(() => import(/* webpackChunkName: "lc-job-posting" */ "../../lazy_components/job_posting"));
const ModalLoader = require("../smart_inquiry/ModalLoader");

class Loader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  componentDidMount() {
    document.addEventListener("loadJobPosting", this.loadAndRedirect);

    if (window.__openJobPostingOnLoad) {
      window.__openJobPostingOnLoad = false;
      this.setState({ loaded: true, initialTarget: document });
    }
  }

  loadAndRedirect = (event) => {
    const { loaded } = this.state;

    if (loaded) {
      event.target.dispatchEvent(new CustomEvent("openJobPosting", { bubbles: true }));
    } else {
      this.setState({
        loaded: true,
        initialTarget: event.target,
      });
    }
  }

  render() {
    const { loaded, initialTarget } = this.state;

    if (loaded) {
      return (
        <React.Suspense fallback={<ModalLoader />}>
          <JobPostingForm
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...this.props}
            initialTarget={initialTarget}
          />
        </React.Suspense>
      );
    }

    return (
      <div />
    );
  }
}

Loader.propTypes = {
  initialTarget: PropTypes.any,
};

Loader.defaultProps = {
  initialTarget: null,
};

module.exports = Loader;
